export default "__VITE_ASSET__bb684834__"